<template>
    <div id="app">
        <v-toolbar flat dark :app="true" clipped-left :color="getColoring" height="40px">
            <!-- color="rgb(70, 70, 75)" -->

            <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>

            <v-toolbar-title>
                <div class="flex">
                    <img src="../assets/logo.png" class="d-inline-block displayed" alt="congatec" height="35px">
                </div>

            </v-toolbar-title>

            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn id="navigation_pool_button" small flat to="/macpools" v-if="poolRead && loggedIn">MAC Pools
                </v-btn>
                <v-btn id="navigation_pool_group_button" small flat to="/poolgroups" v-if="poolGroupRead && loggedIn">
                    Pool Groups
                </v-btn>
                <v-btn id="navigation_user_button" small flat to="/users" v-if="userRead && loggedIn">Users</v-btn>
                <v-btn id="navigation_role_button" small flat to="/roles" v-if="roleRead && loggedIn">Roles</v-btn>
                <v-btn id="navigation_protocol_button" small flat to="/protocol" v-if="protocolRead && loggedIn">
                    Protocol
                </v-btn>
                <v-btn id="navigation_setting_button" small flat to="/settings" v-if="settingRead && loggedIn">
                    Settings
                </v-btn>
            </v-toolbar-items>

            <v-spacer></v-spacer>

            <v-toolbar-items>

                <v-btn id="navigation_current_user_info_button" small flat @click.stop="showCurrentUser=true"
                       v-if="loggedIn">
                    <v-icon small left>fas fa-user</v-icon>
                    <v-icon small left v-if="!showCurrentUser">fas fa-arrow-down</v-icon>
                    <v-icon small left v-if="showCurrentUser">fas fa-arrow-up</v-icon>
                </v-btn>
                <v-btn id="navigation_login_button" small flat to="/login" v-else>
                    <v-icon small left>fas fa-sign-in-alt</v-icon>
                    <span>Login</span>
                </v-btn>

                <CurrentUserInfo v-model="showCurrentUser" :loggedIn="loggedIn" :name="name" :username="username"/>
            </v-toolbar-items>
        </v-toolbar>

        <v-navigation-drawer
                :app="true"
                dark
                v-model="drawer"
                temporary
                width="200"
                id="drawer">
            <v-btn small flat to="/macpools">MAC Pools</v-btn>
            <v-btn small flat to="/poolgroups">Pool Groups</v-btn>
            <v-btn small flat to="/users">Users</v-btn>
            <v-btn small flat to="/roles">Roles</v-btn>
            <v-btn small flat to="/protocol">Protocol</v-btn>
            <v-btn small flat to="/settings">Settings</v-btn>
        </v-navigation-drawer>
    </div>
</template>

<script>

    import CurrentUserInfo from './common/users/modals/CurrentUserInfo'
    import configmanager from "../managers/configmanager";

    export default {
        name: "Navigation",

        data: () => ({
            drawer: false,
            fav: true,
            menu: false,
            message: false,
            hints: true,
            showCurrentUser: false

        }),

        components: {
            CurrentUserInfo
        },

        props: {
            loggedIn: Boolean,
            poolRead: Boolean,
            poolGroupRead: Boolean,
            userRead: Boolean,
            roleRead: Boolean,
            protocolRead: Boolean,
            settingRead: Boolean,
            username: String,
            name: String
        },

        computed: {
            getColoring() {
                let environment = null
                configmanager.getEnvironment(env => {
                    environment = env;
                })

                if (environment !== null) {
                    if (environment === "PROD" || environment === "LOCAL") {
                        return 'rgb(70, 70, 75)'
                    } else if (environment === "TEST") {
                        return 'light-blue darken-4'
                    } else if (environment === "DEV") {
                        return 'green darken-3'
                    }
                }

                return 'rgb(70, 70, 75)'
            }
        }
    };

    document.addEventListener('DOMContentLoaded', function () {
        // Get all "navbar-burger" elements
        var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
        // Check if there are any navbar burgers
        if ($navbarBurgers.length > 0) {
            // Add a click event on each of them
            $navbarBurgers.forEach(function ($el) {
                $el.addEventListener('click', function () {
                    // Get the target from the "data-target" attribute
                    var target = $el.dataset.target;
                    var $target = document.getElementById(target);
                    // Toggle the class on both the "navbar-burger" and the "navbar-menu"
                    $el.classList.toggle('is-active');
                    $target.classList.toggle('is-active');
                });
            });
        }
    });
</script>

<style scoped>
    .flex {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
    }

    .displayed {
        display: block;
        margin-left: auto;
        margin-right: auto
    }
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue